import { DataType, utils as dataUtils } from '@easydata/core';
import { EqValueEditor } from './value_editor';
import { DataKind } from '../types/data_kind';
/**
 * Represents a logical expression or predicate, like comparisions or `LIKE` predicate.
 */
var Operator = /** @class */ (function () {
    /** The default constructor. */
    function Operator() {
        this.id = "";
        this.expr = "";
        this.constValueFormat = "{const}";
        this.caption = "{Unrecognized operator}";
        this.displayFormat = "{expr1} [[{unrecognized operator}]] {expr2}";
        this.isRange = false;
        this.caseIns = false;
        this.paramCount = 2;
        this.defaultOperand = new Operand();
        this.appliedTypes = [];
        this.operands = new Array();
    }
    /**
    * Loads operator from its JSON representation object.
    * @param model The Data Model.
    * @param data The JSON representation object.
    */
    Operator.prototype.loadFromData = function (model, data) {
        if (data) {
            this.id = data.id;
            this.caption = data.cptn;
            this.caseIns = data.caseIns;
            this.isRange = data.isRange;
            this.displayFormat = data.fmt;
            this.paramCount = data.pcnt;
            this.expr = data.expr;
            this.appliedTypes = data.dtypes || this.appliedTypes;
            if (data.defOperand) {
                this.defaultOperand.loadFromData(model, data.defOperand);
            }
            if (data.editor) {
                this.defaultOperand.editor = model.getEditorById(data.editor) || new EqValueEditor();
            }
            if (data.operands) {
                for (var i = 0; i < data.operands.length; i++) {
                    var newOperand = new Operand();
                    newOperand.loadFromData(model, data.operands[i]);
                    if (data.editor) {
                        newOperand.editor = model.getEditorById(data.editor) || new EqValueEditor();
                    }
                    this.operands.push(newOperand);
                }
            }
        }
    };
    return Operator;
}());
export { Operator };
/**
 * Represents one operand in some operator's expression
 */
var Operand = /** @class */ (function () {
    /** The default constructor. */
    function Operand() {
        this.kind = DataKind.Scalar;
        this.dataType = DataType.Unknown;
        this.editor = new EqValueEditor();
        this.defValue = "";
    }
    /**
     * Loads operand from its JSON representation object.
     * @param model The Data Model.
     * @param data The JSON representation object.
     */
    Operand.prototype.loadFromData = function (model, operand) {
        this.kind = operand.kind;
        this.dataType = operand.dtype;
        this.defValue = operand.val;
        this.defText = operand.txt;
        ;
        if (operand.editor) {
            this.editor = model.getEditorById(operand.editor) || new EqValueEditor();
        }
    };
    /**
     * Copies operand from other operand.
     * @param scr The operand.
     */
    Operand.prototype.copyFrom = function (src) {
        dataUtils.assign(this, src);
    };
    return Operand;
}());
export { Operand };
//# sourceMappingURL=operator.js.map